import * as TeamActions from '../actions/TeamActions'
import {PENDING, FULFILLED, REJECTED} from '../actions/constants';
import update from 'immutability-helper';

export default (state = {
    fetched: false,
    fetching: false,
    active: null,
    billingAdded: false,
    addingBilling: false,
    billingError: null,

    billing: null,
    fetchingBilling: false,
    fetchedBilling: false,
}, action) => {
    switch (action.type){
        case TeamActions.FETCH_TEAM + PENDING:
            return update(state, {
                fetching: {$set: true}
            });
        case TeamActions.FETCH_TEAM + FULFILLED:
            return update(state, {
                active: {$set: action.payload},
                fetching: {$set: false},
                fetched: {$set: true}
            });

        case TeamActions.ADD_BILLING + PENDING:
            return update(state, {
                addingBilling: {$set: true},
                billingError: {$set: null}
            })

        case TeamActions.ADD_BILLING + FULFILLED:
            return update(state, {
                addingBilling: {$set: false},
                billingAdded: {$set: true},
                active: {$set: null},
                fetched: {$set: false},
            })

        case TeamActions.ADD_BILLING + REJECTED:
            return update(state, {
                addingBilling: {$set: false},
                billingAdded: {$set: false},
                billingError: {$set: action.payload.message}
            });

        case TeamActions.FETCH_BILLING + PENDING:
            return update(state, {
                fetchingBilling: {$set: true},
                fetchedBilling: {$set: false},
            })
        case TeamActions.FETCH_BILLING + FULFILLED:
            return update(state, {
                billing: {$set: action.payload},
                fetchingBilling: {$set: false},
                fetchedBilling: {$set: true},
            });

        case TeamActions.RETRY_BILLING:
            return update(state, {
                billing: {$set: null},
                billingAdded: {$set: false},
                addingBilling: {$set: false},
                billingError: {$set: null},
                fetchingBilling: {$set: null},
                fetchedBilling: {$set: null},
            });
        case TeamActions.RESET_BILLING_ADDED:
            return update(state, {
                billingAdded: {$set: false},
            });


        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/TeamsReducer.js